<template>
  <div v-if="!hasPermission('List Place Visit Value')">Você não tem permissão para acessar esta página!</div>
  <div v-else>

    <Toolbar>
      <template #actions v-if="!place.place_is_marketplace">
        <button class="btn btn-sm btn-primary" v-if="!isEnabledSellMarketplace"
                type="button" @click="openMarketplaceModal()">
            <i class="bi bi-shop fs-3 me-2"></i> Vender no markteplace
        </button>
        <button class="btn btn-sm btn-danger" v-else
                type="button" @click="disableSellMarketplace()">
          <i class="bi bi-ban"></i> Parar de vender no markteplace
        </button>
      </template>
    </Toolbar>

    <!-- Modal de Habilitação do Marketplace -->
    <div class="modal fade" id="modalEnableMarketplace" tabindex="-1" aria-labelledby="modalEnableMarketplaceLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalEnableMarketplaceLabel">
              <i class="bi bi-shop fs-3 me-2"></i>
              Vender no Marketplace Ubbimed
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-6">
              <h4 class="text-primary mb-4">
                <i class="bi bi-info-circle me-2"></i>
                O que é o Marketplace Ubbimed?
              </h4>
              <p class="text-gray-700 fs-6 mb-0">
                O Marketplace Ubbimed é uma plataforma que conecta profissionais de saúde a novos pacientes,
                ampliando sua visibilidade e permitindo que mais pessoas tenham acesso aos seus serviços. 
                Ao participar, você amplia exponencialmente seu alcance, conectando sua expertise a uma
                demanda crescente por cuidados de qualidade e atraindo um fluxo contínuo de novos pacientes.
              </p>
            </div>

            <div class="mb-6">
              <h4 class="text-primary mb-4">
                <i class="bi bi-star me-2"></i>
                Vantagens de Vender no Marketplace
              </h4>
              <ul class="list-unstyled">
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Maior Visibilidade:</strong> Alcance novos pacientes que buscam atendimento na plataforma
                </li>
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Gestão Simplificada:</strong> Todos os agendamentos centralizados em um só lugar
                </li>
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Aumento de Receita:</strong> Preencha horários vagos com novos pacientes
                </li>
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Controle Total:</strong> Você define seus valores
                </li>
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Pagamento Garantido:</strong> Sistema seguro de pagamento integrado e pagamento no dia do atendimento
                </li>
                <li class="mb-3">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Gratuito:</strong> Nós não cobramos mensalidade ou taxa de adesão. Você só paga uma pequena comissão por consulta realizada
                </li>
              </ul>
            </div>

            <div class="mb-6">
              <h4 class="text-primary mb-4">
                <i class="bi bi-gear me-2"></i>
                Como Funciona?
              </h4>
              <div class="timeline">
                <div class="timeline-item mb-4">
                  <div class="d-flex align-items-start">
                    <div class="badge badge-circle badge-primary me-3">1</div>
                    <div>
                      <strong>Ativação:</strong> Ao confirmar, seus serviços ficarão visíveis no marketplace
                    </div>
                  </div>
                </div>
                <div class="timeline-item mb-4">
                  <div class="d-flex align-items-start">
                    <div class="badge badge-circle badge-primary me-3">2</div>
                    <div>
                      <strong>Configuração:</strong> Os valores e políticas de cancelamento cadastrados serão utilizados
                    </div>
                  </div>
                </div>
                <div class="timeline-item mb-4">
                  <div class="d-flex align-items-start">
                    <div class="badge badge-circle badge-primary me-3">3</div>
                    <div>
                      <strong>Agendamentos:</strong> Pacientes poderão agendar consultas com você através da plataforma
                    </div>
                  </div>
                </div>
                <div class="timeline-item mb-4">
                  <div class="d-flex align-items-start">
                    <div class="badge badge-circle badge-primary me-3">4</div>
                    <div>
                      <strong>Atendimento:</strong> Você receberá notificações e poderá gerenciar tudo pela sua agenda
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="alert alert-warning d-flex align-items-center">
              <i class="bi bi-exclamation-triangle-fill fs-2 me-3"></i>
              <div>
                <strong>Importante:</strong> Ao ativar esta opção, você concorda com os 
                <a href="#" class="text-primary">termos de uso</a> e 
                <a href="#" class="text-primary">políticas</a> do marketplace Ubbimed.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              <i class="bi bi-x-circle me-1"></i>
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="confirmEnableMarketplace()">
              <i class="bi bi-check-circle me-1"></i>
              Sim, quero vender no marketplace!
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Edição da Política de Cancelamento -->
    <div class="modal fade" id="modalEditCancelPolicy" tabindex="-1" aria-labelledby="modalEditCancelPolicyLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalEditCancelPolicyLabel">
              <i class="bi bi-shield-exclamation fs-3 me-2"></i>
              Editar política de cancelamento
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    @click="closeEditPolicyModal()"></button>
          </div>
          <div class="modal-body" v-if="editingPolicy">
            <div class="row mb-5">
              <div class="col-md-8">
                <label class="form-label fw-bold required">Nome da política</label>
                <input type="text"
                       class="form-control"
                       v-model="editingPolicy.policy_cancel_name"
                       maxlength="190"
                       placeholder="Ex.: Pop, Light, Flex"/>
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <div class="form-check mt-4">
                  <input class="form-check-input" type="checkbox" id="editingPolicyIsCommon"
                         v-model="editingPolicy.is_common">
                  <label class="form-check-label fw-bold" for="editingPolicyIsCommon">
                    Política Popular
                  </label>
                </div>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label fw-bold">Descrição / Texto da política</label>
              <div style="height: 200px; overflow-y: auto;">
                <QuillEditor
                    ref="cancelPolicyEditor"
                    class="form-control-solid border rounded"
                    :value="editingPolicy.policy_cancel_desc"
                    :options="cancelPolicyEditorOptions"
                    height="200"
                    style="height: 200px; overflow-y: auto;"
                    @change="onPolicyEditorChange"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-5">
                <label class="form-label fw-bold">Prazo para cancelamento (dias)</label>
                <input type="number"
                       class="form-control"
                       min="0"
                       v-model.number="editingPolicy.policy_cancel_deadline"
                       placeholder="Ex.: 2"/>
              </div>
              <div class="col-md-6 mb-5">
                <label class="form-label fw-bold">Prazo para reagendamento (dias)</label>
                <input type="number"
                       class="form-control"
                       min="0"
                       v-model.number="editingPolicy.reschedule_deadline"
                       placeholder="Ex.: 2"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="closeEditPolicyModal()">
              <i class="bi bi-x-circle me-1"></i>
              Cancelar
            </button>
            <button type="button" class="btn btn-primary"
                    :disabled="isSavingPolicy || !editingPolicy || !editingPolicy.policy_cancel_name"
                    @click="savePolicy()">
              <span v-if="!isSavingPolicy">
                <i class="bi bi-check-circle me-1"></i>
                Salvar
              </span>
              <span v-else>
                Salvando...
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

      <div class="container-xxl">
        <div class="col-xl-12 mb-xl-10">
          <div class="card h-md-100">
            <div class="card-body pt-5">
              <ul class="nav nav-pills nav-pills-custom mb-3">
                <li class="nav-item mb-3 me-3 me-lg-6" v-for="(kind, index) in kinds">
                  <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                     data-bs-toggle="pill" :class="{ 'active': kind.id_kind === kindIdSelected }"
                     @click="setKindIdSelected(kind.id_kind, index)">
                    <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">{{ kind.kind_name }}</span>
                    <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                  </a>
                </li>
              </ul>
              <div v-if="kindIndexSelected !== null" class="tab-content">
                <div class="tab-pane fade active show" id="{{'tab_' + kindIndexSelected}}">
                  <div class="table-responsive">
                    <table class="table table-row-bordered align-middle gs-0 gy-4 my-0 table-hover">
                      <thead>
                      <tr class="fs-7 fw-bolder text-gray-500 border-bottom-0">
                        <th rowspan="2" class="ps-0 min-w-140px">Especialidade</th>
                        <template v-for="(policy, index) in kinds[kindIndexSelected].canceling_policies"
                                  :key="policy.id_policy_cancel">
                          <th :colspan="policy.id_plan ? 3 : 2" class="text-center min-w-140px"
                              :class="{'bg-gray-200': index % 2 === 0,
                                     'bg-gray-300': index % 2 !== 0
                                    }">
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-truncate" :title="policy.policy_cancel_name">
                                {{ policy.policy_cancel_name }}
                              </span>
                              <button
                                v-if="hasPermission('Update CancelingPolicy')"
                                type="button"
                                class="btn btn-icon btn-sm btn-light-primary ms-2"
                                @click.stop="openEditPolicyModal(policy)"
                                :title="'Editar política de cancelamento'">
                                <i class="bi bi-pencil-square"></i>
                              </button>
                            </div>
                          </th>
                        </template>
                      </tr>
                      <tr class="fs-7 fw-bolder text-gray-500 border-bottom-2">
                        <template v-for="(policy, index) in kinds[kindIndexSelected].canceling_policies"
                                  :key="'sub-' + policy.id_policy_cancel">
                          <th class="ps-0 text-center"
                              style="width: 150px;"
                              :class="{'bg-gray-200': index % 2 === 0,
                                     'bg-gray-300': index % 2 !== 0
                                    }">
                            Valor Sugerido
                          </th>
                          <th class="ps-0 text-center"
                              style="width: 150px;"
                              :class="{'bg-gray-200': index % 2 === 0,
                                     'bg-gray-300': index % 2 !== 0
                                    }">
                            Valor Personalizado
                          </th>
                          <template v-if="policy.id_plan">
                            <th class="ps-0 text-center"
                                style="width: 150px;"
                                :class="{'bg-gray-200': index % 2 === 0,
                                       'bg-gray-300': index % 2 !== 0
                                      }">
                              Valor de Repasse
                            </th>
                          </template>
                        </template>
                      </tr>
                      </thead>
                      <tbody v-for="(specialty,specIndex) in kinds[kindIndexSelected].specialties" :key="specialty.id_spec">
                      <tr :key="'row-'+specialty.id_spec">
                        <td class="ps-0">
                          <span @click="toggleExpand(specIndex)"><i class="bi ms-2 me-4"
                                                                    :class="isExpanded(specIndex) ? 'bi-dash-circle' : 'bi-plus-circle'"></i></span>
                          <span class="text-gray-800 fw-bolder text-hover-primary mb-1 fs-6 text-start pe-0">{{
                              specialty.spec_name
                            }}</span>
                        </td>
                        <template
                            v-for="(policy,policyIndex) in specialty.canceling_policies"
                            :key="policy.id_policy_cancel">
                          <td class="text-center min-w-140px"
                              :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                            {{
                              'R$ ' + maskValue(policy.value_default)
                            }}
                          </td>
                          <td class="text-center min-w-140px pe-4"
                              :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                            <money3
                                v-if="true || !place.use_default_visit_values"
                                class="form-control form-control-sm text-center"
                                v-model="policy.value_place_spec"
                                v-bind="config"
                                @focus="beginVisitValueEdit(policy, null, 'value')"
                                @blur="commitVisitValue(specialty, policy, null, 'value')"></money3>
                            <span v-else-if="place.use_default_visit_values && policy.value_place_spec" class="text-gray-800 text-hover-primary mb-1 fs-6 pe-0 ms-10">{{'R$ ' + maskValue(policy.value_place_spec)}}</span>
                          </td>
                          <template v-if="policy.id_plan">
                            <td class="text-center min-w-140px pe-4"
                                :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                              <money3
                                  v-if="true || !place.use_default_visit_values"
                                  class="form-control form-control-sm text-center"
                                  v-model="policy.transfer_value_place_spec"
                                  v-bind="config"
                                  @focus="beginVisitValueEdit(policy, null, 'transfer')"
                                  @blur="commitVisitValue(specialty, policy, null, 'transfer')"></money3>
                              <span v-else-if="place.use_default_visit_values && policy.transfer_value_place_spec" class="text-gray-800 text-hover-primary mb-1 fs-6 pe-0 ms-10">{{ 'R$ ' + maskValue(policy.transfer_value_place_spec) }}</span>
                            </td>
                          </template>
                        </template>
                      </tr>
                      <tr v-for="(professional) in kinds[kindIndexSelected].specialties[specIndex].professionals"
                          :key="'prof-' + specialty.id_spec"
                          v-if="isExpanded(specIndex)">
                        <td class="ps-0">
                           <span class="text-gray-800 text-hover-primary mb-1 fs-6 pe-0 ms-10">{{
                               professional.prof_name
                             }}</span>
                        </td>
                        <template
                            v-for="(policy,policyIndex) in professional.canceling_policies"
                            :key="policy.id_policy_cancel">
                          <td class="text-center min-w-140px"
                              :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                            {{
                              'R$ ' + maskValue(kinds[kindIndexSelected].specialties[specIndex].canceling_policies[policyIndex].value_default)
                            }}
                          </td>
                          <td class="text-center min-w-140px pe-4"
                              :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                            <money3
                                v-if="true || !place.use_default_visit_values"
                                class="form-control form-control-sm text-center"
                                v-model="policy.value_place_prof"
                                v-bind="config"
                                @focus="beginVisitValueEdit(policy, professional.id_prof, 'value')"
                                @blur="commitVisitValue(specialty, policy, professional.id_prof, 'value')">
                            </money3>
                            <span v-else-if="place.use_default_visit_values && policy.value_place_prof" class="text-gray-800 text-hover-primary mb-1 fs-6 pe-0 ms-10">{{'R$ ' + maskValue(policy.value_place_prof)}}</span>
                          </td>
                          <template v-if="kinds[kindIndexSelected].specialties[specIndex].canceling_policies[policyIndex].id_plan">
                            <td class="text-center min-w-140px pe-4"
                                :class="{'bg-gray-200': policyIndex % 2 === 0,
                                     'bg-gray-300': policyIndex % 2 !== 0
                                    }">
                              <money3
                                  v-if="true || !place.use_default_visit_values"
                                  class="form-control form-control-sm text-center"
                                  v-model="policy.transfer_value_place_prof"
                                  v-bind="config"
                                  @focus="beginVisitValueEdit(policy, professional.id_prof, 'transfer')"
                                  @blur="commitVisitValue(specialty, policy, professional.id_prof, 'transfer')">
                              </money3>
                              <span v-else-if="place.use_default_visit_values && policy.transfer_value_place_prof" class="text-gray-800 text-hover-primary mb-1 fs-6 pe-0 ms-10">{{ 'R$ ' + maskValue(policy.transfer_value_place_prof) }}</span>
                            </td>
                          </template>
                        </template>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>

</template>

<script>
import http from "../../helpers/http";
import Permission from "../../helpers/permission";
import Input from "../attendance/shared/Input";
import {Money3Component} from 'v-money3'
import Alert from "../../helpers/alert";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import Modal from "../../helpers/modal";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import QuillEditor from "vue-quill-editor/src/editor.vue";

export default {
  name: "VisitValues",
  components: {Input, money3: Money3Component, Toolbar, QuillEditor,},
  data() {
    return {
      kinds: [],
      kindIdSelected: '',
      kindIndexSelected: null,
      isEnabledSellMarketplace: false,
      beforeValue: 0,
      beforeTransfer: 0,
      config: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: !this.hasPermission('Update Place Visit Value'),
        min: null,
        max: null,
        allowBlank: true,
        minimumNumberOfCharacters: 0,
        shouldRound: false,
        focusOnRight: false,
      },
      expandedRows: [],
      editingPolicy: null,
      isSavingPolicy: false,
      cancelPolicyEditorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{align: []}],
            ['clean'],
          ],
        },
      },
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.loadVisitValues();
    this.checkIsEnabledSellMarketplace();
  },
  methods: {
    checkIsEnabledSellMarketplace() {
      http.get(`/places/${this.place.id_place}/is-enable-sell-marketplace`).then(response => {
        this.isEnabledSellMarketplace = response.data.is_enabled;
      });
    },
    openMarketplaceModal() {
      Modal.toggle('#modalEnableMarketplace');
    },
    confirmEnableMarketplace() {
      http.patch(`/places/${this.place.id_place}/enable-sell-marketplace`).then(_ => {
        Modal.toggle('#modalEnableMarketplace');
        Alert.toastSuccess('Agora você está vendendo no marketplace!');
        this.isEnabledSellMarketplace = true;
        this.loadVisitValues();
      }).catch(e => {
        this.isEnabledSellMarketplace = false;
        Alert.toastError(e.response.data.message ?? e.response.data);
      });
    },
    disableSellMarketplace() {
      Swal.fire({
        title: 'Você tem certeza?',
        text: "Ao desativar essa opção, você concorda em parar de vender seus serviços no marketplace, sujeito às políticas e termos de uso da plataforma.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero parar de vender no marketplace!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          http.patch(`/places/${this.place.id_place}/disable-sell-marketplace`).then(_ => {
            Alert.toastSuccess('Você não está mais vendendo no marketplace!');
            this.isEnabledSellMarketplace = false;
            this.loadVisitValues();
          }).catch(e => {
            this.isEnabledSellMarketplace = true;
            Alert.toastError(e.response.data.message ?? e.response.data);
          });
        }
      });
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadVisitValues() {
      http.get(`/places/${this.place.id_place}/visit-values`).then((response) => {
        this.kinds = response.data;
        if (this.kinds.length > 0) {
          this.setKindIdSelected(this.kinds[0].id_kind, 0);
        }
      });
    },
    setKindIdSelected(kindId, index) {
      this.expandedRows = [];
      this.kindIdSelected = kindId;
      this.kindIndexSelected = index;
    },
    maskValue(value) {
      if (!value) return '';
      const formatedValue = Number(value).toFixed(2);
      return formatedValue.replace('.', ',')
    },
    onPolicyEditorChange(event) {
      if (!this.editingPolicy) {
        return;
      }
      this.editingPolicy.policy_cancel_desc = event.html;
    },
    openEditPolicyModal(policy) {
      this.editingPolicy = {
        id_policy_cancel: policy.id_policy_cancel,
        policy_cancel_name: policy.policy_cancel_name,
        policy_cancel_desc: policy.policy_cancel_desc,
        policy_cancel_deadline: policy.policy_cancel_deadline,
        reschedule_deadline: policy.reschedule_deadline,
        is_common: !!policy.is_common,
      };

      Modal.toggle('#modalEditCancelPolicy');
    },
    closeEditPolicyModal() {
      this.editingPolicy = null;
      this.isSavingPolicy = false;
    },
    savePolicy() {
      if (!this.editingPolicy || !this.editingPolicy.policy_cancel_name) {
        return;
      }

      this.isSavingPolicy = true;

      const payload = {
        policy_cancel_name: this.editingPolicy.policy_cancel_name,
        policy_cancel_desc: this.editingPolicy.policy_cancel_desc,
        policy_cancel_deadline: this.editingPolicy.policy_cancel_deadline ?? 0,
        reschedule_deadline: this.editingPolicy.reschedule_deadline ?? 0,
        is_common: this.editingPolicy.is_common,
      };

      http.put(`/places/${this.place.id_place}/canceling-policies/${this.editingPolicy.id_policy_cancel}`, payload)
        .then(() => {
          Alert.toastSuccess('Política de cancelamento atualizada com sucesso.');
          this.closeEditPolicyModal();
          this.loadVisitValues();
          Modal.toggle('#modalEditCancelPolicy');
        })
        .catch(e => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Erro ao atualizar política de cancelamento.');
        })
        .finally(() => {
          this.isSavingPolicy = false;
        });
    },
    beginVisitValueEdit(policy, profId, field) {
      if (field === 'transfer' && !policy.id_plan) {
        return;
      }
      if (profId) {
        if (field === 'value') {
          this.beforeValue = policy.value_place_prof;
        } else {
          this.beforeTransfer = policy.transfer_value_place_prof;
        }
      } else {
        if (field === 'value') {
          this.beforeValue = policy.value_place_spec;
        } else {
          this.beforeTransfer = policy.transfer_value_place_spec;
        }
      }
    },
    commitVisitValue(specialty, policy, profId, field) {
      if (field === 'transfer' && !policy.id_plan) {
        return;
      }
      let current;
      let previous;
      if (field === 'value') {
        current = profId ? policy.value_place_prof : policy.value_place_spec;
        previous = this.beforeValue;
      } else {
        current = profId ? policy.transfer_value_place_prof : policy.transfer_value_place_spec;
        previous = this.beforeTransfer;
      }
      if (previous === current) {
        return;
      }
      const payload = {
        id_spec: specialty.id_spec,
        id_policy_cancel: policy.id_policy_cancel,
        id_prof: profId,
      };
      if (field === 'value') {
        payload.value = current;
      } else {
        payload.transfer_value = current;
      }
      http.put(`/places/${this.place.id_place}/visit-values`, payload)
        .then(_ => Alert.toastSuccess('Valor atualizado com sucesso'))
        .catch(e => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data);
        });
    },
    toggleExpand(specIndex) {
      const index = this.expandedRows.indexOf(specIndex);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(specIndex);
      }
    },
    isExpanded(specIndex) {
      return this.expandedRows.includes(specIndex);
    },
  },
}
</script>

<style scoped>
</style>